import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import Login from "@/pages/Login";
import Marketplace from "@/pages/Marketplace";
import Portfolio from "@/pages/Portfolio";
import PropertyDetail from "@/pages/PropertyDetail";
import { getUser } from "@/lib/auth";

const RequireAuth = ({ children }) => {
  const u = getUser();
  return u ? children : <Navigate to="/" replace />;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route
            path="/marketplace"
            element={
              <RequireAuth>
                <Marketplace />
              </RequireAuth>
            }
          />
          <Route
            path="/portfolio"
            element={
              <RequireAuth>
                <Portfolio />
              </RequireAuth>
            }
          />
          <Route
            path="/property/:id"
            element={
              <RequireAuth>
                <PropertyDetail />
              </RequireAuth>
            }
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <Toaster
          position="top-right"
          toastOptions={{
            style: {
              background: "#0F172A",
              color: "#F8FAFC",
              border: "1px solid #1E293B",
              fontFamily: "Manrope, sans-serif",
            },
          }}
          data-testid="toaster"
        />
      </BrowserRouter>
    </div>
  );
}

export default App;
